var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import SingleFilter from './single-filter';
import MultipleFilter from './multiple-filter';
export default function Filter(props) {
    var _a = props.type, type = _a === void 0 ? 'single' : _a;
    if (['single', 'select'].includes(type)) {
        return React.createElement(SingleFilter, __assign({}, props));
    }
    return React.createElement(MultipleFilter, __assign({}, props));
}
//# sourceMappingURL=index.js.map